export default [
  {
    value: 'guests',
    text: 'Покупатель',
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'roomType',
    text: 'Отель',
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'room',
    text: 'Тип номера',
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'price',
    text: 'Цена',
    width: 120,
    align: 'end',
    type: 'string',
    description: ''
  },
  {
    value: 'status',
    text: 'Статус',
    width: 240,
    type: 'string',
    sortable: false,
    description: ''
  },
  {
    value: 'createdAt',
    text: 'Создано',
    width: 180,
    type: 'date',
    description: ''
  },
  {
    value: 'actions',
    text: 'Действия',
    width: 60,
    align: 'end',
    type: 'actions',
    sortable: false,
    description: ''
  }
]
